import React from 'react';
import { PatientPreviewTemplate } from 'themes/application/patient/pages';
import { observer } from 'mobx-react';
import { PatientPreviewViewStore } from 'application/patient/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore) => new PatientPreviewViewStore(rootStore), 'patientPreviewViewStore')
@observer
class PatientPreview extends React.Component {
    render() {
        return <PatientPreviewTemplate {...this.props} />
    }
}

export default PatientPreview;
